__turbopack_context__.v({
  "candidate": "ThemePreviewDialog-module__i9I4_a__candidate",
  "candidateFlush": "ThemePreviewDialog-module__i9I4_a__candidateFlush",
  "email": "ThemePreviewDialog-module__i9I4_a__email",
  "frame": "ThemePreviewDialog-module__i9I4_a__frame",
  "heading": "ThemePreviewDialog-module__i9I4_a__heading",
  "paragraph": "ThemePreviewDialog-module__i9I4_a__paragraph",
});
